import { Color } from '@diritto/common/style/color';

export enum ButtonType {
  Primary = 'Primary',
  Secondary = 'Secondary',
  SecondaryNeutral = 'SecondaryNeutral',
  SecondaryNoBorder = 'SecondaryNoBorder',
  SecondaryNeutralNoBorder = 'SecondaryNeutralNoBorder',
  SecondaryBlackNoBorder = 'SecondaryBlackNoBorder',
  NaturalNoBorder = 'NaturalNoBorder',
  KakaoLogin = 'KakaoLogin',
  NaverLogin = 'NaverLogin',
  RidiLogin = 'RidiLogin',
  TwitterLogin = 'TwitterLogin',
  GoogleLogin = 'GoogleLogin',
  AppleLogin = 'AppleLogin',
}

export enum ButtonSize {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
  XSmall = 'XSmall',
}

export const ButtonHeight = {
  [ButtonSize.Large]: 56,
  [ButtonSize.Medium]: 48,
  [ButtonSize.Small]: 40,
  [ButtonSize.XSmall]: 30,
};

export const ButtonPadding = {
  [ButtonSize.Large]: {
    horizontal: 24,
  },
  [ButtonSize.Medium]: {
    horizontal: 20,
  },
  [ButtonSize.Small]: {
    horizontal: 16,
  },
  [ButtonSize.XSmall]: {
    horizontal: 12,
  },
};

export const ButtonColor = {
  [ButtonType.Primary]: {
    backgroundColor: Color.Primary500,
    color: Color.White,
    borderColor: Color.Primary500,
  },
  [ButtonType.Secondary]: {
    backgroundColor: 'transparent',
    color: Color.Primary500,
    borderColor: Color.Primary500,
  },
  [ButtonType.SecondaryNeutral]: {
    backgroundColor: 'transparent',
    color: Color.Gray600,
    borderColor: Color.Gray300,
  },
  [ButtonType.NaturalNoBorder]: {
    backgroundColor: Color.Gray200,
    color: Color.Gray600,
    borderColor: 'transparent',
  },
  [ButtonType.SecondaryNoBorder]: {
    backgroundColor: 'transparent',
    color: Color.Primary500,
    borderColor: 'transparent',
  },
  [ButtonType.SecondaryNeutralNoBorder]: {
    backgroundColor: 'transparent',
    color: Color.Gray400,
    borderColor: 'transparent',
  },
  [ButtonType.SecondaryBlackNoBorder]: {
    backgroundColor: 'transparent',
    color: Color.Black,
    borderColor: 'transparent',
  },
  [ButtonType.KakaoLogin]: {
    backgroundColor: Color.Kakao,
    color: Color.Black,
    borderColor: Color.Kakao,
  },
  [ButtonType.NaverLogin]: {
    backgroundColor: Color.Naver,
    color: Color.White,
    borderColor: Color.Naver,
  },
  [ButtonType.TwitterLogin]: {
    backgroundColor: Color.White,
    color: Color.Twitter,
    borderColor: Color.White,
  },
  [ButtonType.GoogleLogin]: {
    backgroundColor: Color.White,
    color: Color.Black,
    borderColor: Color.Gray300,
  },
  [ButtonType.AppleLogin]: {
    backgroundColor: Color.Black,
    color: Color.White,
    borderColor: Color.Black,
  },
  [ButtonType.RidiLogin]: {
    backgroundColor: Color.Black,
    color: Color.White,
    borderColor: Color.Black,
  },
};

// Bottom Button Height
export const MobileBottomButtonHeight = 77;
export const BottomButtonHeight = 85;
